import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, {useEffect, useState} from "react";
import AcademicYearInput from "./AcademicYearInput";
import { RadioButtonGroupInput, TextInput, required } from "react-admin";
import DaysOfWeekInput from "components/DaysOfWeekInput";
import AddressAutoCompleteInput from "components/AddressAutoCompleteInput";
import { AcademicYearResources } from "utils/tools";
import moment from "moment/moment";
import StudentScheduleStartDateInput from "../../../components/StudentScheduleStartDateInput";
import {useField} from "react-final-form";

const RegularCostCalculationInput = () => {
  const [idAcademicYear, setIdAcademicYear] = useState<number>(0);

  const academicYearField = useField("academicYearId");
  const date = useField("date");

  const academicYearResources = AcademicYearResources(idAcademicYear);

  const academicYearCallback = (value: number) => {
    setIdAcademicYear(value);
  };

  useEffect(() => {
    academicYearField.input.onChange("");
    date.input.onChange("");
    academicYearCallback(0)
  }, []);

  return (
    <Card variant="outlined" style={{ marginBottom: 20 }}>
      <CardContent>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Regular Schedule</Typography>
          </Grid>

          <Grid item xs={4}>
            <AcademicYearInput parentCallback={academicYearCallback} />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <StudentScheduleStartDateInput
              source="date"
              label="Start Date *"
              parentStartDate={moment
                .utc(academicYearResources?.startDate)
                .format("yyyy-MM-DD")}
              parentEndDate={moment
                .utc(academicYearResources?.endDate)
                .format("yyyy-MM-DD")}
            />
          </Grid>

          <Grid item xs={12}>
            <RadioButtonGroupInput
              label="To and/or From"
              source="wayType"
              choices={[
                { id: "OneWayMorning", name: "Morning (Bus to School)" },
                {
                  id: "OneWayAfternoon",
                  name: "Afternoon (Bus from School)",
                },
                { id: "TwoWay", name: "Both" },
              ]}
              validate={required()}
            />
          </Grid>

          <DaysOfWeekInput />

          <Grid item xs={12}>
            <Typography variant="h6">Pick up & Drop off Address</Typography>
          </Grid>

          <Grid item xs={4}>
            <AddressAutoCompleteInput
              label="Postal Code *"
              source="postalCode"
              referenceSource="locationData"
            />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={2}>
            <TextInput label="Unit No." source="unit" />
          </Grid>
          <Grid item xs={2}>
            <TextInput label="Block No." source="blockNumber" />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <TextInput label="Building Name" source="building" />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <TextInput label="Street" source="street" validate={required()} />
          </Grid>
          <Grid item xs={8}></Grid>
        </SanitizedGrid>
      </CardContent>
    </Card>
  );
};

export default RegularCostCalculationInput;
